import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';


@Component({
    selector: 'app-autologout-confirm-dialog',
    templateUrl: './autologout-confirm-dialog.component.html',
    styleUrls: ['./autologout-confirm-dialog.component.css'],
    standalone: false
})
export class AutologoutConfirmDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { message: string },
    private dialogRef: MatDialogRef<AutologoutConfirmDialogComponent>,
    matDialog: MatDialog
  ) {}

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
}
